// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WJoIw{position:relative;width:100%;height:100%;min-height:220px;border-radius:12px;overflow:hidden;background-image:linear-gradient(45deg, #eaeaef 25%, transparent 25%),linear-gradient(-45deg, #eaeaef 25%, transparent 25%),linear-gradient(45deg, transparent 75%, #eaeaef 75%),linear-gradient(-45deg, transparent 75%, #eaeaef 75%);background-size:16px 16px;background-position:0 0,0 8px,8px -8px,-8px 0;padding:16px;display:flex;align-items:center;justify-content:center}.fABoB{width:100%;height:100%;min-height:188px;border-radius:8px;overflow:hidden;display:flex;border:1px solid #d4d4e0;box-shadow:0 2px 8px rgba(40,40,99,.08)}.LSE60{flex:0 0 32%;padding:16px;display:flex;flex-direction:column;gap:16px;background:#fff}.XPNQT{width:56px;height:44px;border-radius:6px;display:flex;align-items:center;justify-content:flex-start;overflow:hidden}.XPNQT.B40Wb{border:1px solid #d4d4e0;background:#fff}.VfPHo{max-width:100%;max-height:100%;object-fit:contain}.iDtFR{width:100%;height:100%;background:transparent}.yspKW{display:flex;flex-direction:column;gap:6px}.MuuU6{width:75%;height:3px;border-radius:2px;margin-bottom:4px}.kaB2l,.EqEy1,.SeCfD{width:75%;height:3px;border-radius:2px;opacity:.5}.lbAqM{border-top-left-radius:8px;flex:1;padding:20px;display:flex;flex-direction:column;gap:12px;align-items:flex-end}.Aj8QN{width:100%;display:flex;flex-direction:column;gap:6px}.VNcXp{width:55%;height:4px;border-radius:2px;opacity:.4}.awHcj{width:35%;height:4px;border-radius:2px;opacity:.4}.Kmoyi{width:100%;display:flex;align-items:center;gap:8px;border-radius:6px;padding:8px 12px}.Eougt{height:4px;border-radius:2px;opacity:.3}.dweXV{flex-shrink:0;font-size:14px;font-weight:600;line-height:1;margin-left:auto}.n31K7{width:64px;height:16px;border-radius:4px;margin-top:auto}.ilFyH{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.4)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `WJoIw`,
	"card": `fABoB`,
	"leftPanel": `LSE60`,
	"logoSlot": `XPNQT`,
	"logoSlotEmpty": `B40Wb`,
	"logoImage": `VfPHo`,
	"logoEmpty": `iDtFR`,
	"leftLines": `yspKW`,
	"leftLineActive": `MuuU6`,
	"leftLineWide": `kaB2l`,
	"leftLineMedium": `EqEy1`,
	"leftLineShort": `SeCfD`,
	"rightPanel": `lbAqM`,
	"titleBlock": `Aj8QN`,
	"titleLine": `VNcXp`,
	"subtitleLine": `awHcj`,
	"lineItem": `Kmoyi`,
	"lineItemTrack": `Eougt`,
	"dollarSign": `dweXV`,
	"brandButton": `n31K7`,
	"loadingOverlay": `ilFyH`
};
export default ___CSS_LOADER_EXPORT___;
